
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor02Off as ObiCapacitor02OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-02-off.js';
 
 
 

 
 export const ObiCapacitor02Off = createComponent({
   react: React,
   tagName: 'obi-capacitor-02-off',
   elementClass: ObiCapacitor02OffElement,
   events: {
     
   }
  });
 
 